module.exports = __webpack_public_path__ + "img/tab2.dfbaad87.png";